import iconPrediction from "assets/img/icons/craft-prediction.svg";
import iconIdentity from "assets/img/icons/craft-identity.svg";
import iconClaimPrize from "assets/img/icons/claim-prize.svg";
import ActiveItemDivider from "./ActiveItemDivider";
import ActiveItemCancelListing from "./ActiveItemCancelListing";
import ActiveItemCraftButton from "./ActiveItemCraftButton";
import ActiveItemSellButton from "./ActiveItemSellButton";
import ActiveItemRedeem from "./ActiveItemRedeem";
import useActiveItem from "hooks/useActiveItem";

const ActiveItemCommonButtons = ({ pathname, isListed }) => {
  const {activeItem} = useActiveItem();

  const { type, tag } = activeItem;

  const linkPath =
    type === "Identity" ? "/crafting/prediction" : '';

  const predictionButtonIcon = tag.toLowerCase() === 'resolved true' ? iconClaimPrize : iconIdentity;


  const permittedPaths = [
    {
      url: "/dashboard",
      text: type === "Prediction" ? tag : "Craft Prediction",
      icon: type === "Prediction" ? predictionButtonIcon : iconPrediction,
      linkPath,
    },
    {
      url: "/dates",
      text: "Craft Identity",
      icon: iconIdentity,
      linkPath: "/crafting/identity",
    },
    {
      url: "/categories",
      text: "Craft Identity",
      icon: iconIdentity,
      linkPath: "/crafting/identity",
    },
    {
      url: "/identities",
      text: "Craft Prediction",
      icon: iconPrediction,
      linkPath: "/crafting/prediction",
    },
    {
      url: "/events",
      text: "Craft Prediction",
      icon: iconPrediction,
      linkPath: "/crafting/prediction",
    },
    {
      url: "/triggers",
      text: "Craft Prediction",
      icon: iconPrediction,
      linkPath: "/crafting/prediction",
    },
    {
      url: "/prizes",
      text: "Craft Prediction",
      icon: iconPrediction,
      linkPath: "/crafting/prediction",
    },
    {
      url: "/predictions",
      text: tag,
      icon: predictionButtonIcon,
      linkPath: "",
    },
  ];

  const matchedPath = permittedPaths.find((item) =>
    pathname.includes(item.url)
  );

  if (!activeItem || !activeItem.type || !activeItem.tag) {
    return null;
  }

  const isTutorItem = !!activeItem.properties.find((item) => item.text.toLowerCase() === 'tutorial' )


  if (matchedPath) {
    return (
      <>
        <div className="card-details__buttons">

          {tag !== 'Redeemable' && (<ActiveItemCraftButton data={matchedPath} isListed={isListed} />)}
          {tag === 'Redeemable' ?  <ActiveItemRedeem  /> : null }
          {
            !isTutorItem ?
            (isListed ? <ActiveItemCancelListing /> : <ActiveItemSellButton />)
            :
            null
          }
        </div>
        {!pathname.includes("/dashboard") && <ActiveItemDivider />}
      </>
    );
  }
};

export default ActiveItemCommonButtons;
